<span *ngIf="property?.Value !== null && format; else errorTemplate">
  <span *ngIf="property?.Value === 0">-</span>
  <span *ngIf="property?.Value !== 0">{{ value | number : format }}</span>
</span>
<ng-template #errorTemplate>
  <app-message-icon [messageLevel]="0"></app-message-icon>
</ng-template>
